export const DIALOG_VISIBILITY = {
    show: 'show',
    hide: 'hide',
    hideAndRefresh: 'hideAndRefresh'
}
